import { LinkButton } from 'framework/ui/ui-builder';
import { useAuthorization } from 'framework/authorization';
import { useProjectId } from 'domain/shared/project';
import { START_PROJECT_REVIEW, useNewProjectUrl } from 'domain/shared/newProject';

const StartProjectReviewButton = () => {
  const { getCreateProjectReviewUrl } = useNewProjectUrl();
  const { isGranted } = useAuthorization();
  const projectId = useProjectId();

  if (!isGranted(START_PROJECT_REVIEW)) return null;

  return (
    <LinkButton variant="contained" color="primary" url={getCreateProjectReviewUrl(projectId)}>
      Start project review
    </LinkButton>
  );
};

export default StartProjectReviewButton;
